import { Component, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { CommonModule } from '@angular/common';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';

import { CommodityOfferLabels } from '../../../commodity-offers.model';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-commodity-offer-budgetbill-proposal',
  templateUrl: './commodity-offer-budgetbill-proposal.component.html',
  styleUrls: [
    './commodity-offer-budgetbill-proposal.component.ed.scss',
    './commodity-offer-budgetbill-proposal.component.essent.scss',
  ],
  standalone: true,
  imports: [CommonModule, ToolTipComponent, RoundedCurrencyPipe],
})
export class CommodityOfferBudgetbillProposalComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() termijnbedragVariantA = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() termijnbedragVariantB = false;
}
